{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "UserSettingDefinition",
  "definitions": {
    "UserSettingSchema": {
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "invite_id": {
          "type": "string",
          "readOnly": true
        }
      }
    }
  }
}
